// extracted by css-extract-rspack-plugin
export default {"cell":"cell-aThArF","icon":"icon-B92von","tooltip":"tooltip-w_0YgK"};